import { mapNewsSearchHitToPageHit, mapPageSearchHitToPageHit } from '@app-domains/meilisearch/mappers/content-hit.mapper'
import { ContentSearchResult } from '@app-domains/meilisearch/types/content-search.types'
import { PageHit } from '@app-types/page.types'
import { InstantSearchSearchResult } from '@app-domains/meilisearch/mappers/instantsearch-response.mapper'

export function mapContentSearchResult(
    result: ContentSearchResult,
    indexName: string,
    query: string,
): InstantSearchSearchResult<PageHit> {
    const hits = result.hits.map(({ hit, type }) =>
        type === 'page'
            ? mapPageSearchHitToPageHit(hit as any)
            : mapNewsSearchHitToPageHit(hit as any),
    )

    return {
        hits,
        nbHits: result.totalHits,
        page: result.page - 1,
        nbPages: result.totalPages,
        hitsPerPage: result.perPage,
        processingTimeMS: result.processingTimeMs,
        exhaustiveNbHits: true,
        exhaustiveFacetsCount: true,
        query,
        params: '',
        index: indexName,
    }
}
